module.exports = __webpack_public_path__ + "static/media/image_4.7da9755e.png";